/**
 * @author vishwadeep.kapoor
 * ActivateZsc reducer
 *
 */

import { fromJS } from 'immutable';
import { DEFAULT_ACTION, ZSC_ACTIVATION_SUCCESS } from './constants';

export const initialState = fromJS({ isLoading: false, response: {} });

function activateZscReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case ZSC_ACTIVATION_SUCCESS:
      return state.set('response', fromJS(payload));
    default:
      return state;
  }
}

export default activateZscReducer;



// WEBPACK FOOTER //
// client/containers/ActivateZsc/reducer.js